import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Music } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const REDIRECT_URL = `${window.location.origin}/admin/callback`;
const AUTH_URL = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(REDIRECT_URL)}`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && user) {
      navigate('/admin/dashboard');
    }
  }, [user, loading, navigate]);

  const handleLogin = () => {
    window.location.href = AUTH_URL;
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="login-header">
          <img 
            src="https://customer-assets.emergentagent.com/job_lethbridge-angels/artifacts/znfka10j_RA-blacktransparent%20cropped%20no%20vol.png" 
            alt="Rebel Angels" 
            className="login-logo"
          />
          <h1 className="login-title">Admin Panel</h1>
          <p className="login-subtitle">Manage your shows and band members</p>
        </div>
        <Button className="login-button" onClick={handleLogin}>
          <Music className="button-icon" />
          Sign in with Google
        </Button>
      </div>
    </div>
  );
};

export default AdminLogin;
